import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { CurrentUserService } from './core/services/user/current-user.service';
import { UserRole } from '../enums/roles.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private currentUserService: CurrentUserService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const currentUser = this.currentUserService.GetSession();
    if (currentUser && currentUser.token) {
      // Admin
      if (currentUser.role === UserRole.Admin) {
        return true;
      }
      // Dermatologist
      else if (currentUser.role === UserRole.Dermatologist) {
        if (
          state.url.startsWith('/consultation') ||
          state.url.startsWith('/dermoscan') ||
          state.url.startsWith('/dashboard') ||
          state.url.startsWith('/patient/detail') ||
          state.url.startsWith('/report/dermotologist-report')
        ) {
          return true;
        } else {
          this.router.navigate(['/consultation/list']);
          return false;
        }
      }
      // GP
      else if (currentUser.role === UserRole.GeneralPractitioner) {
        if (
          state.url.startsWith('/consultation') ||
          state.url.startsWith('/patient') ||
          state.url.startsWith('/dashboard') ||
          state.url.startsWith('/appointment') ||
          state.url.startsWith('/referral') ||
          state.url.startsWith('/invoice')
        ) {
          return true;
        } else {
          this.router.navigate(['/patient/list']);
          return false;
        }
      } else {
        return true;
      }
    } else {
      this.router.navigate(['/login']);

      return false;
    }
  }
}
